<template>
  <div>
    <el-dialog :show-close="false" :visible="visible" width="95%" @close="visible = false">
      <div class="title">请选择需要确认的预估月份</div>
      <el-select
        placeholder="预估窗口"
        v-model="estimateWindowInfo.estimateTimeId"
        allowClear
        @change="handleEstimateWindow"
        v-if="showTree"
      >
        <el-option
          v-for="item in estimateWindowList"
          :key="item.estimateTimeId"
          :label="item.ym + ' ' + item.version"
          :value="item.estimateTimeId"
        >
          {{ item.ym }} {{ item.version }}
        </el-option>
      </el-select>
      <div class="title mt10">确认预估后，所选岗位及下级不可编辑预估数量</div>
      <el-tree
        v-if="showTree"
        checkable
        :data="treeData"
        :props="props"
        node-key="serialNum"
        :expand-on-click-node="false"
        default-expand-all
        check-on-click-node
        show-checkbox
        :default-checked-keys="defaultCheckedKeys"
        @check="onCheck"
      >
      </el-tree>
      <div class="btn-group">
        <el-button class="btn" round @click="visible = false">取消</el-button>
        <el-button class="btn" type="primary" round @click="confirmEstimate">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import _ from 'lodash'
import moment from 'moment'

export default {
  components: {},
  data() {
    return {
      visible: false,
      estimateWindowList: [], // 预估窗口下拉框
      estimateWindowInfo: {}, // 预估窗口下拉框默认值
      treeLoading: false,
      showTree: true,
      treeData: [],
      props: { children: 'lockDataList', label: 'userName' },
      defaultCheckedKeys: [],
    }
  },
  filters: {},
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    edit() {
      this.getEstimateWindow()
      this.visible = true
    },
    // 获取预估弹框窗口信息
    getEstimateWindow() {
      postAction('/sip/estimate/overview/getWindowPeriodListWithinWindowPeriod').then(res => {
        console.log('获取预估弹框窗口信息---------', res)
        if (res.result.length > 0) {
          this.estimateWindowList = res.result
          this.estimateWindowInfo = res.result[0]
          this.getEstimateUser(this.estimateWindowInfo)
        }
      })
    },
    // 获取确认预估用户树
    getEstimateUser(params) {
      this.treeLoading = true
      this.treeData = []
      this.defaultCheckedKeys = []
      getAction('/sip/estimate/overview/getInWindowPeriodUserInfo', params)
        .then(res => {
          console.log('获取确认预估用户树---------', res)
          if (res.success) {
            const obj = res.result
            if (obj.confirm == 1) {
              this.defaultCheckedKeys.push(obj.serialNum)
            }
            if (obj.lockDataList) {
              obj.lockDataList.forEach(v => {
                if (v.confirm == 1) {
                  this.defaultCheckedKeys.push(v.serialNum)
                }
              })
            }
            this.treeData.push(obj)
            this.showTree = true
          }
        })
        .catch(() => {
          this.treeLoading = false
        })
        .finally(() => {
          this.treeLoading = false
        })
    },

    // 选择预估窗口信息
    handleEstimateWindow(val) {
      this.showTree = false
      this.estimateWindowInfo = this.estimateWindowList.filter(item => {
        return item.estimateTimeId == val
      })
      this.getEstimateUser(this.estimateWindowInfo[0])
    },
    onCheck(checkedNodes, checkedParmas) {
      let serialNums = []
      serialNums.push(this.treeData[0].serialNum)

      if (checkedParmas.checkedKeys.indexOf(this.treeData[0].serialNum) != -1) {
        this.treeData[0].confirm = 1
      } else {
        this.treeData[0].confirm = 0
      }
      if (this.treeData[0].lockDataList) {
        this.treeData[0].lockDataList.forEach(item => {
          serialNums.push(item.serialNum)
          if (checkedParmas.checkedKeys.indexOf(item.serialNum) != -1) {
            item.confirm = 1
          } else {
            item.confirm = 0
          }
          if (checkedParmas.checkedKeys.length == 0) {
            item.confirm = 0
          }
        })
      }
    },
    // 确认预估按钮
    confirmEstimate() {
      let params = {
        ...this.treeData[0],
        ...this.estimateWindowInfo,
      }
      postAction('/sip/estimate/overview/confirmEstimate', params).then(res => {
        this.$toast(res.result)
        this.visible = false
      })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 30px;
  padding-top: 0;
}
.mt10 {
  margin-top: 10px;
}
.title {
  margin-bottom: 10px;
}
.btn-group {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .btn {
    width: 140px;
    height: 43px;
  }
}
</style>
